import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TickerBar = () => {
  const [tickers, setTickers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTickers = async () => {
      try {
        const res = await axios.get(`${API}/tickers?active_only=true`);
        setTickers(res.data);
      } catch (error) {
        console.error("Error fetching tickers:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTickers();
  }, []);

  // Don't render if no tickers
  if (loading || tickers.length === 0) return null;

  // Create the scrolling text content
  const tickerContent = tickers.map((t, i) => (
    <span key={t.id} className="inline-flex items-center">
      {t.link_url ? (
        <a 
          href={t.link_url}
          className="hover:text-[#E91E8C] transition-colors"
        >
          {t.text}
        </a>
      ) : (
        <span>{t.text}</span>
      )}
      {i < tickers.length - 1 && (
        <span className="mx-16"></span>
      )}
    </span>
  ));

  return (
    <div 
      className="w-full bg-black text-white overflow-hidden"
      style={{ height: '53px' }}
      data-testid="ticker-bar"
    >
      <div className="h-full flex items-center">
        <div className="ticker-scroll whitespace-nowrap">
          {/* Duplicate content for seamless loop */}
          <span className="ticker-content">
            {tickerContent}
            <span className="mx-16"></span>
          </span>
          <span className="ticker-content">
            {tickerContent}
            <span className="mx-16"></span>
          </span>
          <span className="ticker-content">
            {tickerContent}
            <span className="mx-16"></span>
          </span>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@700&display=swap');
        
        .ticker-scroll {
          display: inline-flex;
          animation: ticker-scroll 25s linear infinite;
          font-family: 'Oswald', sans-serif;
          font-size: 1.5rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }
        
        .ticker-scroll:hover {
          animation-play-state: paused;
        }
        
        .ticker-content {
          display: inline-flex;
          align-items: center;
        }
        
        @keyframes ticker-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.33%);
          }
        }
      `}</style>
    </div>
  );
};
